import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.447 21.9998c-.524 0-1.065 0-1.065-.786v-3.916c0-1.18-.393-1.933-.852-2.327 2.802-.311 5.751-1.376 5.751-6.209 0-1.377-.491-2.507-1.295-3.376.132-.327.558-1.606-.13-3.342-1.049-.328-3.458 1.294-3.458 1.294-.999-.278-2.08-.426-3.146-.426-1.065 0-2.146.148-3.14495.426 0 0-2.409-1.622-3.474-1.294-.672 1.736-.246 3.015-.114 3.342-.804.869-1.295 1.999-1.295 3.376 0 4.817 2.932 5.898 5.734 6.209-.359.328-.688.869-.802 1.688-.721.328-2.556.885-3.654-1.049-.688-1.196-1.933-1.294-1.933-1.294-1.23-.017-.083.77-.083.77.819.377 1.394 1.835 1.394 1.835.737 2.245 4.243 1.491 4.243 1.491 0 1.049.016 2.507.016 2.802 0 .786-.557.786-1.081.786H16.447z",
    fill: "currentColor"
  }));
});